import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Platform } from 'src/app/models/Platform';

@Injectable({ providedIn: 'root' })
export class PlatformsService {
  constructor(private http: HttpClient) { }

  listAll(): Observable<Platform[]> {
    return this.http.get<Platform[]>(`${environment.apiUrl}/platforms`);
  }

  filter(name: string): Observable<Platform[]> {
    return this.http.get<Platform[]>(`${environment.apiUrl}/platforms?name=${encodeURIComponent(name)}`);
  }
}
